import { find, trim , toUpper, get} from 'lodash';
export const duplicateCheck = (collection, field, obj) => {
    const selected = find(collection, (ele) => {
        // eslint-disable-next-line
        return trim(ele[field]) == trim(obj[field])
    })
    // eslint-disable-next-line
    if (selected && (!obj.id || selected.id != obj.id)) {
        return true
    }
    return false;
}

export const GetClientOrDependentName = (data)=>{
    let name = ""
    switch(get(data.occupantType, "code")){
        case "CLIENT":
            name = `${toUpper(data.client.firstName)} ${toUpper(data.client.lastName)}`
        break;
        case "DEPENDENT": 
            name = `${data.dependentName} (${toUpper(data.client.firstName)} ${toUpper(data.client.lastName)})`
        break;
        default:
        break
    }
    return name;
}